import white from "../assets/pt/whitePT.png";
import blue from "../assets/pt/bluePT.png";
import black from "../assets/pt/blackPT.png";
import red from "../assets/pt/redPT.png";
import green from "../assets/pt/greenPT.png";
import gold from "../assets/pt/goldPT.png";
import colourless from "../assets/pt/colourlessPT.png";

const colours = {
  W: white,
  U: blue,
  B: black,
  R: red,
  G: green,
};

const ptBuilder = (power, toughness, font, cardColour) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 170;
  canvas.height = 90;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.font = font;
  //console.log(`colour identity is ${cardColour}`);
  return new Promise((resovle, reject) => {
    const img = document.createElement("img");
    img.src = getIdent(cardColour);
    img.onload = () => resovle(img);
  }).then((img) => {
    ctx.drawImage(img, 0, 0);
    const ptString = `${power}/${toughness}`;
    const halfTextLength = Math.round(ctx.measureText(ptString).width / 2);
    const halfCanvas = Math.round(canvas.width / 2);
    const x = halfCanvas - halfTextLength;
    ctx.fillText(ptString, x, 57);
    return canvas.toDataURL("image/png");
  });
};

const getIdent = (c) => {
  if (c.length === 0) {
    return colourless;
  } else if (c.length > 1) {
    return gold;
  } else {
    return colours[c];
  }
};

export default ptBuilder;
